import { API_CONFIG } from '@/page/config/base_config.js'
const suffixes = [
  'doc', 'dot', 'wps', 'wpt', 'docx', 'dotx', 'docm', 'dotm', 'rtf',
  'xls', 'xlt', 'et', 'xlsx', 'xltx', 'csv', 'xlsm', 'xltm',
  'ppt', 'pptx', 'pptm', 'ppsx', 'ppsm', 'pps', 'potx', 'potm', 'dpt', 'dps'
]
const isWPS = (suffix) => {
  if (API_CONFIG.OFFICE_ONLINE_TYPE === 'wps') {
    if (suffixes.includes(suffix)) {
      return true
    }
  }
  return false
}

const operateIds = ['edit', 'down', 'version', 'delete', 'view']

export {
  isWPS,
  operateIds
}
